import { FormSelectComponent } from "./components/form-select.component";
import { FormButtonComponent } from "./components/form-button.component";
import { FormHiddenComponent } from "./components/form-hidden.component";
import { FormDualListBoxComponent } from "./components/form-dual-list-box.component";
import { FormSelectMultipleComponent } from "./components/form-select-multiple.component";
import { FormFileUploadComponent } from "./components/form-file-upload/form-file-upload.component";
import { FormListComponent } from "./components/form-list.component";
import { FormTextareaComponent } from "./components/form-textarea.component";
import { FormDateComponent } from "./components/form-date.component";
import { FormObjectComponent } from "./components/form-object.component";
import { FormPasswordComponent } from "./components/form-password.component";
import { FormCheckboxComponent } from "./components/form-checkbox.component";
import { FormInputComponent } from "./components/form-input.component";
import { FormSelectMultipleCheckComponent } from "./components/form-select-multiple-check.component";
import { FormLineComponent } from "./components/form-line.component";
import { FormEditorComponent } from "./components/form-editor/form-editor.component";
import { FormArrayComponent } from "./components/form-array.component";
import { FormInputSearchComponent } from "./components/form-input_search.component";
import { FormGoogleMapComponent } from "./components/form-googlemap.component";
import { FormFormbuilderComponent } from "./components/form-formbuilder/form-formbuilder.component";
import { FormLeadexportComponent } from "./components/form-leadexport/form-leadexport.component";
import { FormCampaignmanagementComponent } from "./components/form-campaignmanagement/form-campaignmanagement.component";
import { FormNewslettercontentsComponent } from "./components/form-newslettercontents/form-newslettercontents.component";
import { FormUsermanagementComponent } from "./components/form-usermanagement/form-usermanagement.component";
import { FormUserimporttoolComponent } from "./components/form-userimporttool/form-userimporttool.component";
import { FormEditorialClientComponent } from "./components/form-editorial-client/form-editorial-client.component";
import { FormDatatableComponent } from "./components/form-datatable/form-datatable.component";
import { FormTimepickerComponent } from "./components/form-timepicker/form-timepicker.component";
import { FormLeadqualificationComponent } from "./components/form-leadqualification/form-leadqualification.component";
import { FormLinksComponent } from "./components/form-links/form-links.component";
import { FormBlacklistComponent } from "./components/form-blacklist/form-blacklist.component";
import { FormGallerybuilderComponent } from "./components/form-gallerybuilder/form-gallerybuilder.component";

export const DYNAMIC_FIELDS = {
	button: FormButtonComponent,
	input: FormInputComponent,
	bulkinput: FormInputComponent,
	input_search: FormInputSearchComponent,
	hidden: FormHiddenComponent,
	password: FormPasswordComponent,
	select: FormSelectComponent,
	select_multiple: FormSelectMultipleComponent,
	select_multiple_check: FormSelectMultipleCheckComponent,
	checkbox: FormCheckboxComponent,
	textarea: FormTextareaComponent,
	textarea_json: FormTextareaComponent,
	editor: FormEditorComponent,
	date: FormDateComponent,
	datetime: FormDateComponent,
	object: FormObjectComponent,
	systeminfo: FormObjectComponent,
	list: FormListComponent,
	dual_list: FormDualListBoxComponent,
	image_upload: FormFileUploadComponent,
	file_upload: FormFileUploadComponent,
	line: FormLineComponent,
	array_static: FormArrayComponent,
	assignments: FormArrayComponent,
	google_map: FormGoogleMapComponent,
	formbuilder: FormFormbuilderComponent,
	leadexport: FormLeadexportComponent,
	campaignmanagement: FormCampaignmanagementComponent,
	newslettercontents: FormNewslettercontentsComponent,
	usermanagement: FormUsermanagementComponent,
	userimporttool: FormUserimporttoolComponent,
	editorialclient: FormEditorialClientComponent,
	formdatatable: FormDatatableComponent,
	time: FormTimepickerComponent,
	leadqualification: FormLeadqualificationComponent,
	links: FormLinksComponent,
	blacklist: FormBlacklistComponent,
	gallerybuilder: FormGallerybuilderComponent,
};
